import { createAction, props } from '@ngrx/store';
import { GerichtProfile, GerichtProfileResource } from './gerichtprofile.model';

const PREFIX = '[Gericht Profile] ';

export const loadGerichtProfileAction = createAction(PREFIX + 'Load Gericht Profile');

export const loadGerichtProfileSuccessAction = createAction(
	PREFIX + 'Load Gericht Profile Success',
	props<{
		gerichtProfile: GerichtProfileResource;
	}>()
);

export const updateGerichtProfileAction = createAction(
	PREFIX + 'Update Gericht Profile',
	props<{
		gerichtProfile: GerichtProfile;
	}>()
);

export const updateGerichtProfileSuccessAction = createAction(
	PREFIX + 'Update Gericht Profile Success Action',
	props<{
		gerichtProfile: GerichtProfileResource;
	}>()
);
